module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid17_800x750.5664f99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid17_800x750.jpg
// module id = VoxJ
// module chunks = 0